import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { Container, Title, ContentText, ContentLink } from './term.styles';

const Term = _ref => {
  let {
    terms,
    placeholders = {}
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["terms", "placeholders"]);

  const parseText = text => text && Object.entries(placeholders).reduce((acc, [placeholder, value]) => acc.replace(`{${placeholder}}`, value), text);

  const checkFinancialService = financialService => {
    return Object.entries(placeholders).find(([placeholder, value]) => placeholder.startsWith(financialService) && value);
  };

  return terms.map(term => {
    var _term$content;

    return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
      key: term == null ? void 0 : term.id
    }), /*#__PURE__*/React.createElement(Title, {
      as: "p"
    }, parseText(term == null ? void 0 : term.title)), (!(term != null && term.financialService) || checkFinancialService(term.financialService)) && /*#__PURE__*/React.createElement(ContentText, {
      "data-testid": term.id
    }, term == null ? void 0 : (_term$content = term.content) == null ? void 0 : _term$content.map(content => {
      var _content$text;

      return content.link ? /*#__PURE__*/React.createElement(ContentLink, {
        as: "a",
        href: content == null ? void 0 : content.link,
        key: content == null ? void 0 : content.link
      }, parseText(content == null ? void 0 : content.text)) : content == null ? void 0 : (_content$text = content.text) == null ? void 0 : _content$text.map(item => /*#__PURE__*/React.createElement(ContentText, {
        as: "span",
        key: item.content
      }, item != null && item.bold ? /*#__PURE__*/React.createElement("b", null, parseText(item == null ? void 0 : item.content)) : parseText(item == null ? void 0 : item.content)));
    })));
  });
};

process.env.NODE_ENV !== "production" ? Term.propTypes = {
  terms: arrayOf(shape({
    id: string,
    title: string,
    texts: arrayOf(string)
  }))
} : void 0;
Term.defaultProps = {
  terms: []
};
export default Term;